/* Language Switcher */

const flags = {
  de: `<svg width="24" height="24" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_37_276)"> <g clip-path="url(#clip1_37_276)"> <path d="M266.333 0H-67V200H266.333V0Z" fill="black"/> <path d="M266.333 66.6667H-67V200H266.333V66.6667Z" fill="#DD0000"/> <path d="M266.333 133.333H-67V200H266.333V133.333Z" fill="#FFCE00"/> </g> </g> <defs> <clipPath id="clip0_37_276"> <rect width="200" height="200" fill="white"/> </clipPath> <clipPath id="clip1_37_276"> <rect width="200" height="200" rx="100" fill="white"/> </clipPath> </defs> </svg>`,
  en: `<svg width="24" height="24" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_38_270)"> <g clip-path="url(#clip1_38_270)"> <path d="M-67 0V200H266.333V0H-67Z" fill="#012169"/> <path d="M-67 0L266.333 200ZM266.333 0L-67 200Z" fill="black"/> <path d="M-67 0L266.333 200M266.333 0L-67 200" stroke="white" stroke-width="40"/> <mask id="mask0_38_270" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-67" y="0" width="334" height="200"> <path d="M99.6667 100H266.333V200L99.6667 100ZM99.6667 100V200H-67L99.6667 100ZM99.6667 100H-67V0L99.6667 100ZM99.6667 100V0H266.333L99.6667 100Z" fill="white"/> </mask> <g mask="url(#mask0_38_270)"> <path d="M-67 0L266.333 200ZM266.333 0L-67 200Z" fill="black"/> <path d="M-67 0L266.333 200M266.333 0L-67 200" stroke="#C8102E" stroke-width="26.6667"/> </g> <path d="M-73.667 73.3333H72.9997V-6.66666H126.333V73.3333H273V126.667H126.333V206.667H72.9997V126.667H-73.667V73.3333Z" fill="#C8102E" stroke="white" stroke-width="13.3333"/> </g> </g> <defs> <clipPath id="clip0_38_270"> <rect width="200" height="200" fill="white"/> </clipPath> <clipPath id="clip1_38_270"> <rect width="200" height="200" rx="100" fill="white"/> </clipPath> </defs> </svg>`,
  fr: `<svg width="24" height="24" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_38_283)"> <g clip-path="url(#clip1_38_283)"> <path d="M200 0H0V200H200V0Z" fill="#CE1126"/> <path d="M133.333 0H0V200H133.333V0Z" fill="white"/> <path d="M66.6667 0H0V200H66.6667V0Z" fill="#002654"/> </g> </g> <defs> <clipPath id="clip0_38_283"> <rect width="200" height="200" fill="white"/> </clipPath> <clipPath id="clip1_38_283"> <rect width="200" height="200" rx="100" fill="white"/> </clipPath> </defs> </svg>`,
  it: `<svg width="24" height="24" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_38_296)"> <g clip-path="url(#clip1_38_296)"> <path d="M66.6667 0H0V200H66.6667V0Z" fill="#009246"/> <path d="M133.334 0H66.667V200H133.334V0Z" fill="white"/> <path d="M200 0H133.333V200H200V0Z" fill="#CE2B37"/> </g> </g> <defs> <clipPath id="clip0_38_296"> <rect width="200" height="200" fill="white"/> </clipPath> <clipPath id="clip1_38_296"> <rect width="200" height="200" rx="100" fill="white"/> </clipPath> </defs> </svg>`,
};

const languageSwitcher = document.getElementById("language-switcher");

function initializeLanguageSwitcher() {
  if (!Weglot) {
    return;
  }

  var availableLanguages = Weglot.options.languages
    .map(function (language) {
      return language.language_to;
    })
    .concat(Weglot.options.language_from);

  console.log(availableLanguages);

  var selectList = languageSwitcher.querySelector(".dropdown");

  var currentLang = Weglot.getCurrentLang();
  languageSwitcher.querySelector(".selected-display").innerHTML =
    flags[currentLang];

  for (var i = 0; i < availableLanguages.length; i++) {
    var lang = availableLanguages[i];
    var option = document.createElement("li");
    option.classList.add("item");
    option.setAttribute("value", lang);
    option.innerHTML = flags[lang] + Weglot.getLanguageName(lang);
    if (lang === currentLang) {
      option.setAttribute("selected", "");
    }
    selectList.appendChild(option);
  }

  selectList.onchange = function () {
    Weglot.switchTo(this.value);
  };

  Weglot.on("languageChanged", function (lang) {
    selectList.value = lang;
    languageSwitcher.querySelector(".selected-display").innerHTML = flags[lang];
  });
}

window.addEventListener("load", function () {
  initializeLanguageSwitcher();
  var languageSwitcher = document.getElementById("language-switcher");
  const optionsList = languageSwitcher.querySelectorAll(".wrapper-dropdown li");
  for (let o of optionsList) {
    o.addEventListener("click", () => {
      languageSwitcher
        .querySelector("li[selected]")
        .removeAttribute("selected");
      o.setAttribute("selected", "");
      Weglot.switchTo(o.getAttribute("value"));
      //handleDropdown(languageSwitcher, false);
      //document.getElementById("language-switcher").querySelector("svg.arrow").classList.remove("rotated");
      //document.getElementById("language-switcher").classList.remove("active");
    });
  }
});

/* Mega Menu */
let items = document.querySelectorAll(".mega-menu");
let header = document.querySelector("header");
let currentItemIndex;

items.forEach((item, itemIndex) => {
  const content = item.querySelector(".mega-menu__content");
  item.addEventListener("mouseover", () => {
    if (
      (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
      (currentItemIndex && currentItemIndex !== itemIndex)
    ) {
      items[currentItemIndex].removeAttribute("open");
    }

    currentItemIndex = itemIndex;
    item.setAttribute("open", true);
  });

  item.addEventListener("mouseleave", (event) => {
    let close = true;

    const closeTimeout = setTimeout(() => {
      if (close) item.removeAttribute("open");
    }, 200);

    content.addEventListener("mouseover", () => {
      close = false;
    });

    item.addEventListener("mouseover", () => {
      clearTimeout(closeTimeout);
    });
  });

  content.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
  });
});

/* Dropdowns */

const dropdowns = document.querySelectorAll(".wrapper-dropdown");

dropdowns.forEach((dropdown) => {
  const optionsContainer = dropdown.children[2];
  const optionsList = dropdown.querySelectorAll("div.wrapper-dropdown li");

  dropdown.addEventListener("click", (event) => {
    if (dropdown.closest(".crosssell_product") != null) {
      event.preventDefault();
    }

    if (dropdown.classList.contains("active")) {
      if (event.target.closest(".dropdown") == null) {
        handleDropdown(dropdown, false);
      }
    } else {
      let currentActive = document.querySelector(".wrapper-dropdown.active");

      if (currentActive) {
        handleDropdown(currentActive, false);
      }

      handleDropdown(dropdown, true);
    }
  });

  if (dropdown.closest(".crosssell_product") != null) {
    const crossProduct = dropdown.closest(".crosssell_product");
    const productJson = JSON.parse(
      crossProduct.querySelector('[type="application/json"]').textContent
    );
    const crossDropdowns = dropdown
      .closest(".crosssell_product")
      .querySelectorAll(".wrapper-dropdown");

    for (let o of optionsList) {
      o.addEventListener("click", (e) => {
        e.preventDefault();
        if (dropdown.classList.contains("updateTitle")) {
          dropdown.querySelector(".selected-display").innerHTML = o.querySelector("span").innerHTML;
        }

        o.closest(".dropdown")
            .querySelector("li[selected]")
            .removeAttribute("selected");
          o.setAttribute("selected", "");

        if (crossProduct.classList.contains("variants")) {
          let option1 =
            crossDropdowns[0].querySelector("li[selected]").getAttribute("value");
          let option2 =
            crossDropdowns[1].querySelector("li[selected]").getAttribute("value");
          let option3 = null;

          let variant = findCrossVariant(
            productJson,
            option1,
            option2,
            option3
          );
          console.log(
            "option1: " +
              option1 +
              ", option2: " +
              option2 +
              ", option3: " +
              option3
          );
          console.log("Valid: " + variant.id);

          crossProduct
            .querySelector("input")
            .setAttribute("variant_id", variant.id);
          console.log("img: " +  variant.featured_image.src);
          if (variant.featured_image != null) {
            crossProduct.querySelector("img").src = variant.featured_image.src;
          }
          

          crossProduct
            .querySelectorAll(".price > span:last-child")
            .forEach((priceDiv) => {
              priceDiv.innerHTML = Shopify.formatMoney(
                variant.price,
                "{{ amount_with_comma_separator }}€"
              );
            });

          rebuildCrossOptions(
            crossProduct,
            productJson,
            option1,
            option2,
            option3
          );
        }
        closeAllDropdowns();
      });
    }
  }

  // update the display of the dropdown
  if (dropdown.classList.contains("updateTitle") && dropdown.closest(".crosssell_product") == null) {
    for (let o of optionsList) {
      o.addEventListener("click", () => {
        dropdown.querySelector(".selected-display").innerHTML = o.innerHTML;

        if (dropdown.id == "sorting") {
          Shopify.queryParams.sort_by = o.getAttribute("value");
          location.search = new URLSearchParams(Shopify.queryParams).toString();
        }

        closeAllDropdowns();
      });
    }
  }
});

// check if anything else ofther than the dropdown is clicked
window.addEventListener("click", function (e) {
  if (
    e.target.closest(".wrapper-dropdown") == null &&
    e.target.closest(".crosssell_product") == null
  ) {
    closeAllDropdowns();
  }
  if(e.target.closest("li.item") != null && e.target.closest(".wrapper-dropdown").classList.contains("active")){
    closeAllDropdowns();
  }
});

/*
window.addEventListener("click", function (e) {
  let select = e.target.closest(".wrapper-dropdown");
  if (select == null) {
    closeAllDropdowns();
  } else if (select.classList.contains("active")) {
    e.preventDefault();
    closeAllDropdowns();
  } else {
    e.preventDefault();
    let currentActive = document.querySelector(".wrapper-dropdown.active");
    let arrow = select.children[1];

    if (currentActive) {
      handleDropdown(currentActive, false);
    }

    handleDropdown(select, true);
  }
});
*/

// close all the dropdowns
function closeAllDropdowns() {
  dropdowns.forEach((dropdown) => {
    handleDropdown(dropdown, false);
  });
}

// open all the dropdowns
function handleDropdown(dropdown, open) {
  let arrow = dropdown.querySelector("svg.arrow");
  if (open) {
    arrow.classList.add("rotated");
    dropdown.classList.add("active");
  } else {
    arrow.classList.remove("rotated");
    dropdown.classList.remove("active");
  }
}